import axios from 'axios';

const list = async () => {
  const { data } = await axios.get('/group');
  return data;
};

export default list;
